(function () {
  const allPageLinks = document.querySelectorAll("#pills-page a");

  for (const link of allPageLinks) {
    // Skip if path-name already exists (added by PHP template)
    if (link.querySelector(".path-name")) {
      continue;
    }

    const path = link.getAttribute("href");
    const pathParts = path.split("/").filter(part => part !== "");
    const pathElm = document.createElement("span");

    pathElm.classList.add("path-name");
    pathElm.textContent = "/" + pathParts.pop();
    link.appendChild(pathElm);

    if (link.nextElementSibling) {
      const toggleElm = document.createElement("span");
      const srOnlyElm = document.createElement("span");
      toggleElm.classList.add("toggle");
      srOnlyElm.classList.add("sr-only");
      srOnlyElm.textContent = "Toggle";
      toggleElm.appendChild(srOnlyElm);
      link.appendChild(toggleElm);

      link.addEventListener("click", (event) => {
        if (event.target === toggleElm) {
          link.setAttribute(
            "aria-expanded",
            link.getAttribute("aria-expanded") !== "true" ? "true" : "false"
          );
          event.preventDefault();
        }
      });
    }
  }
})();
